import React from 'react';
import styled from 'styled-components';
import navigationIcon from './icons/product-group-paging.svg';
import navigationIconActive from './icons/product-group-paging-active.svg';
import navigationIconHover from './icons/product-group-paging-hover.svg';
import { SCROLL_DIRECTION_LEFT, SCROLL_DIRECTION_RIGHT } from './ProductGroupSlider';
import { THEME_BLACK, themeColor } from '../../../styles/basics/colors';

export type ScrollDirectionType = typeof SCROLL_DIRECTION_LEFT | typeof SCROLL_DIRECTION_RIGHT;

function mapScrollDirectionRotation(scrollDirection: ScrollDirectionType) {
    if (scrollDirection === SCROLL_DIRECTION_RIGHT) {
        return 'rotate(180deg)';
    } else if (scrollDirection === SCROLL_DIRECTION_LEFT) {
        return 'none';
    } else {
        console.error('invalid scroll direction', scrollDirection);
    }
}

const StNavButton = styled.button<{ scrollDirection: ScrollDirectionType }>`
    background-color: rgba(0, 0, 0, 0);
    border: ${themeColor(THEME_BLACK)};
    height: 50px;
    width: 50px;
    cursor: pointer;
    transform: ${({ scrollDirection }) => {
        return mapScrollDirectionRotation(scrollDirection);
    }};
    position: absolute;
    top: 200px;
    z-index: 500;
    left: ${({ scrollDirection }) => {
        if (scrollDirection === SCROLL_DIRECTION_RIGHT) {
            return `auto`;
        } else {
            return `20px`;
        }
    }};
    right: ${({ scrollDirection }) => {
        if (scrollDirection === SCROLL_DIRECTION_RIGHT) {
            return `20px`;
        } else {
            return `auto`;
        }
    }};
    background-image: url(${navigationIcon});

    &:active {
        background-image: url(${navigationIconActive});
    }

    &:hover:not(:active) {
        background-image: url(${navigationIconHover});
    }
`;

interface SliderNavButtonProps {
    isVisible: boolean;
    dataDisplayName: string;
    onClick: () => void;
    scrollDirection: ScrollDirectionType;
}
export function SliderNavButton({ isVisible, dataDisplayName, scrollDirection, onClick }: SliderNavButtonProps) {
    return isVisible ? (
        <StNavButton data-displayname={dataDisplayName} onClick={onClick} scrollDirection={scrollDirection} />
    ) : null;
}
